import { createSelector } from "reselect"
import RootState from "store/state"

export const selectContactSearch = (state: RootState) => state.contactSearch

export const selectScreenRecordingURL = createSelector(
    selectContactSearch,
    (contactSearch) => contactSearch?.screenRecordingURL
)
